import { Alert, TextButton } from '@zillow/constellation-10';
import { ZILLOW_LEASES_EMAIL } from '../../constants/stringConstants';

export default function NoAccessLeaseAlert({ ...props }) {
  return (
    <Alert
      {...props}
      tone="critical"
      actionButton={
        <TextButton asChild tone="brand">
          <a href={`mailto:${ZILLOW_LEASES_EMAIL}`}>Get lease help</a>
        </TextButton>
      }
    >
      You either don’t have access to this lease or this link has expired. Check the link and try again.
    </Alert>
  );
}
